<template>
  <v-container fluid class="e-min-height  primary-gradiente" style="padding-top: 65px;">
    <Diccionario :id_unit="this.idUnidad" :isPractice="true"/>
    <v-layout row wrap class="fill-height" style="min-height: calc(100vh - 96px);">
      <v-flex xs12>
        <v-layout column>
          <HeaderFill title="Práctica Avanzada" :router="`/practica/avanzada/${idUnidad}`" :back="false"/>
          <v-progress-linear  value="100" color="yellow" height="5" class="e-progress"></v-progress-linear>
          <CardFin descripcion="Felicitaciones completaste la práctica avanzada" :route="`/unidad/detalle/${idUnidad}`"/>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CardFin from '../../../components/Practica/Global/CardFin'
export default {
  name: 'cardFinAvanzado',
  props: ['idUnidad'],
  components: {
    CardFin
  }
}
</script>
